<div class="menu" (click)="interceptClickEvent($event)">
  <div class="menu__top">
    <div class="menu__title">
      {{ menu.title }}
    </div>
    <fa-icon tabindex="0" class="menu__close" [icon]="closeIcon"></fa-icon>
  </div>
  <ul class="menu__list" *ngFor="let menuData of menu.items">
    <li>
      @if (menuData.text === 'Admin Entitlement Toggle') {
      <span
        class="flex flex-row justify-content-between align-items-center p-2"
      >
        <label
          for="entitlement-override-switch"
          [style.font-size]="'13px'"
          [style.color]="'var(--text-color)'"
          >Entitlement Override</label
        >
        <p-toggleSwitch
          class="mt-1"
          inputId="entitlement-override-switch"
          [formControl]="entitlementService.adminOverrideControl"
        ></p-toggleSwitch>
      </span>

      } @else {
      <!-- <a
        [attr.gainsight-id]="menuData.gainsightId"
        *ngIf="menuData?.path?.startsWith('http'); else navRouterLink"
        [href]="[menuData.path]"
        >{{ menuData.text }}</a
      > -->
      <a
        *ngIf="menuData?.path?.startsWith('http'); else navRouterLink"
        [href]="[menuData.path]"
        >{{ menuData.text }}</a
      >
      <ng-template #navRouterLink>
        <!-- <a
          [attr.gainsight-id]="menuData.gainsightId"
          [routerLink]="[menuData.path]"
          >{{ menuData.text }}</a
        > -->
        <a [routerLink]="[menuData.path]">{{ menuData.text }}</a>
      </ng-template>
      }
    </li>
  </ul>
</div>
